module.exports = __webpack_public_path__ + "static/media/blank_copy_june_en_2nd.32719bdd.pdf";